<template>
  <v-flex
     xs12
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_from"
          :label="$t('fields.date_from')"
          :clearable="true"
        />
      </v-flex>

      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_to"
          :label="$t('fields.date_to')"
          :clearable="true"
        />
      </v-flex>
      <v-flex xs2 class="mt-6 ml-2">
        <PropagandistSelect
          v-model="filters.propagandist_id"
          :label="$t('fields.propagandist')"
        />
      </v-flex>
      <v-flex xs3 class="mt-3 ml-2">
        <AutoComplete
          :value="searchSchool"
          v-model="searchSchool"
          key-value="id"
          key-name="fullname"
          enable-chips
          enable-clearable
          enable-autofocus
          :items="schools"
          :label="$t('fields.school')"
          @search="searchSchools"
          @input="fetchSchoolsIfExist"
          @clear="deleteSelectedSchools"
          :delay="900"
          :errors="errors"
        >
        </AutoComplete>
      </v-flex>
      <v-spacer></v-spacer>

        <v-btn
          @click="cancelBooked()"
          class="primary mr-2"
          :disabled="!bookSelected.length"
        >{{ $t("CANCEL_RESERVATION") }}
        <span v-if="bookSelected.length">({{ bookSelected.length }})</span>
        </v-btn>

        <MenuBtn
          dark
          :disabled="!totalItems"
          class="primary"
          :title="$t('EXPORT')"
          :items="[
            {title: $t('export_all_booked'), value: '', eventName: 'exportData' },
            {title: $t('export_booked_grouped_by_isbn'), value: 'grouped', eventName: 'exportData' }
          ]"
          @exportData="exportData"
        >

        </MenuBtn>

    </v-row>
    </v-container>
    <v-row>
    <v-col
      cols="12"
    >

    <v-data-table
      v-model="bookSelected"
      :headers="headers"
      :items="items"
      :single-select="false"
      item-key="id"
      show-select
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >


      <template v-slot:[`item.teachers.surname`]="{ item }">
            {{ item.teacher.fullname }}
      </template>

      <template v-slot:[`item.title`]="{ item }">
            {{ item.book.title }}
      </template>

      <template v-slot:[`item.isbn`]="{ item }">
            {{ item.book.isbn }}
      </template>

      <template v-slot:[`item.author`]="{ item }">
            {{ item.book.author }}
      </template>

      <template v-slot:[`item.volume`]="{ item }">
            {{ item.book.volume }}
      </template>

      <template v-slot:[`item.book_type`]="{ item }">
            {{ item.book.book_type }}
      </template>

      <template v-slot:[`item.editor`]="{ item }">
            {{ item.editor.name }}
      </template>

      <template v-slot:[`item.school`]="{ item }">
            {{ item.school.name }}
      </template>

      <template v-slot:[`item.shipping_type`]="{ item }">
           {{ $t(`delivery_methods.${item.campaign_book.shipping_type}`) }}
      </template>

      <template v-slot:[`item.campaign_book.updated_at`]="{ item }">
          {{ getLastStatus(item.campaign_book.statuses).updated_at | timeFormat }}
      </template>

      <template v-slot:[`item.actions`]="{ item }">
           <v-layout wrap>
              <v-flex>

                <v-tooltip bottom :disabled="isDeletable(item.campaign_book.statuses)">
                  <template v-slot:activator="{ on, attrs }">
                    <!-- span: un v-btn disattivato non riceve gli eventi del tooltip -->
                    <span v-bind="attrs" v-on="on">
                      <v-btn
                        icon
                        color="red"
                        :disabled="!isDeletable(item.campaign_book.statuses)"
                        @click="deleteBookedTeacher(item.campaign_book.id)"
                      >
                        <v-icon>cancel</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <span>{{ notDeletableReason(item.campaign_book.statuses) }}</span>
                </v-tooltip>

              </v-flex>
           </v-layout>
      </template>

    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchCampaigns"
    />
    </v-col>
    </v-row>
  </div>
  </v-flex>
</template>
<script>

  import { mapActions } from 'vuex';

  import { campaignsService } from '../../../utils/services/campaigns.service';
  import { campaignsReportService } from '../../../utils/services/campaignsReport.service';

  import { schoolsService } from '../../../utils/services/schools.service';

  import { DeliveryMethods } from '../../../utils/constants/delivery-methods';


  import InputDataPicker from '../../../components/shared/Inputs/InputDataPicker.vue';
  import AutoComplete from '../../../components/shared/Inputs/AutoComplete.vue';
  import PropagandistSelect from '../../../components/shared/Vselects/PropagandistSelect.vue';
  import MenuBtn from '../../../components/shared/Buttons/MenuBtn.vue';
  import Paginator from '../../../components/shared/Paginator';

  export default {
    name: 'CampaignReportBooked',
    components: {
      InputDataPicker,
      AutoComplete,
      PropagandistSelect,
      MenuBtn,
      Paginator,
    },
    data() {
      return {
        loading: false,
        bookSelected: [],
        schools: [],
        searchSchool: null,
        searchSchoolsValue: null,
        items: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['campaign_book.created_at'],
        },

        headers: [
          { text: this.$t('fields.teacher'), value: 'teachers.surname' },
          { text: this.$t('fields.isbn'), value: 'isbn' },
          { text: this.$t('fields.title'), value: 'title' },
          { text: this.$t('fields.volume'), value: 'volume' },
          { text: this.$t('fields.editor'), value: 'editor' },
          { text: this.$t('fields.author'), value: 'author' },
          { text: this.$t('fields.type_shipping'), value: 'shipping_type' },
          { text: this.$t('fields.book_type'), value: 'book_type' },
          { text: this.$t('fields.school'), value: 'school' },
          { text: this.$t('fields.updated_at'), value: 'campaign_book.updated_at' },
          { text: this.$t('fields.actions'), value: 'actions', sortable: false, align: 'center' },
        ],
        filters: {
          date_from: null,
          date_to: null,
          schoolId: 0,
          propagandist_id: 0,
          shipping_type: [DeliveryMethods.HOME, DeliveryMethods.SCHOOL],
        },
      };
    },
    computed: {

      getBookIdSelected() {
        return this.bookSelected.map((e) => e.campaign_book.id);
      },

      requestFilters() {
        const filters = {
          date_from: this.filters.date_from,
          date_to: this.filters.date_to,
          school_id: this.filters.schoolId,
          propagandist_id: this.filters.propagandist_id,
          shipping_type: this.filters.shipping_type,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },

    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      cancelBooked() {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return campaignsService.removeReservation({ ids: this.getBookIdSelected })
              .then(() => {
                this.bookSelected = [];
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.fetchCampaigns(1);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },

      async deleteBookedTeacher(id) {
        this.showConfirm({
            onConfirm: () => {
              this.loading = true;
              return campaignsService.removeReservation({ ids: [id] })
              .then(() => {
                this.showToast({ type: 'success', message: this.$t('DELETED') });
                this.fetchCampaigns(1);
              })
              .catch(error => {
                this.handleError(error, this.errors);
              })
              .finally(() => {
                this.loading = false;
              });
            },
          });
      },

      deleteSelectedSchools() {
        this.filters.schoolId = 0;
      },

      async fetchSchoolsIfExist(id) {
        if (id > 0) {
          this.filters.schoolId = id;
        } else {
          this.filters.schoolId = 0;
        }
      },

      fetchSchools() {
        return schoolsService.index({
          filters: {
            search: this.searchSchoolsValue,
          },
        })
        .then(response => {
            this.schools = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async fetchCampaigns(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return campaignsReportService.teacherReportBooked({
          page: forcePage || page || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      async searchSchools(val) {
        this.searchSchoolsValue = val;
        await this.fetchSchools();
      },

      getLastStatus(items) {
        return items[items.length - 1];
      },

      // Il backend permette la cancellazione solo di libri assegnati o prenotati
      isDeletable(statuses) {
        const last = this.getLastStatus(statuses);
        return !!last && ['ASSIGNED', 'STATUS_BOOKED'].includes(last.status);
      },

      notDeletableReason(statuses) {
        const last = this.getLastStatus(statuses);
        if (!last) {
          return '';
        }
        return this.$t('campaign_book_not_deletable', {
          status: this.$t(`campaign_statuses.${last.status}`),
        });
      },

      downloadContent(content) {
        const url = window.URL.createObjectURL(new Blob([content]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'booked.txt');
        document.body.appendChild(link);
        link.click();
      },

      async exportTeacherReportBooked() {
        this.loading = true;
        return campaignsReportService.teacherReportBooked({
          filters: { ...this.requestFilters, export: true },
        })
          .then(response => {
            this.downloadContent(response.data);
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      async exportTeacherReportBookedGrouped() {
        this.loading = true;
        return campaignsReportService.teacherReportBookedGrouped({
          filters: { ...this.requestFilters, export: true },
        })
          .then(response => {
            this.downloadContent(response.data);
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      exportData(typeExport) {
        switch (typeExport) {
            case 'grouped':
              this.exportTeacherReportBookedGrouped();
              break;
            default:
              this.exportTeacherReportBooked();
          }
      },

    },
    async created() {
      await this.fetchCampaigns(1);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchCampaigns(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchCampaigns(1);
          }
        },
      },

    },
  };
</script>
